import type { ContentBundleEnvelope } from "@safesphere/contracts";

import { serviceWorkerMessageTypes } from "./cachePolicy.js";

export async function cacheVerifiedBundleForOfflineUse(
  bundle: ContentBundleEnvelope,
): Promise<void> {
  if (!("serviceWorker" in navigator)) return;
  const registration = await navigator.serviceWorker.ready;
  registration.active?.postMessage({
    type: serviceWorkerMessageTypes.cacheVerifiedBundle,
    bundle,
  });
}

export function registerOfflineServiceWorker(): void {
  if (!("serviceWorker" in navigator)) return;
  window.addEventListener("load", () => {
    let reloadedForController = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (reloadedForController) return;
      reloadedForController = true;
      window.location.reload();
    });

    void navigator.serviceWorker
      .register("/sw.js")
      .then((registration) => registration.update())
      .catch(() => {
        window.dispatchEvent(new CustomEvent("safesphere:service-worker-unavailable"));
      });
  });
}
